<template>
  <div class="shoppinglist-add-button">
    <button
      class="button-primary"
      v-on:click.prevent="addItem"
      v-if="!isOnList"
      :aria-label="`Zur Merkliste`"
      :tabindex="tabindex"
      role="button"
      @keydown.enter="addItem"
      @keydown.space="addItem"
    >
      <span>Zur Merkliste</span>
      <img
        src="/assets/images/shoppinglist-icon-white.png"
        aria-hidden="true"
        alt="Icon Merkliste hinzufügen"
      />
    </button>
    <button
      class="button button-added"
      v-else
      v-on:click.prevent="removeItem"
      :tabindex="tabindex"
      :aria-label="`Auf der Merkliste`"
      role="button"
      @keydown.enter="removeItem"
      @keydown.space="removeItem"
    >
      <span class="mobile">Auf der Liste</span
      ><span class="desktop">Auf der Merkliste</span>
      <img
        src="/assets/images/shoppinglist-icon-checked.png"
        alt="Icon Merkliste hinzugefügt"
        aria-hidden="true"
      />
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "shoppinglist-add-button",
  props: ["productNr", "productTitle", "tabindex"],
  methods: {
    addItem(event) {
      if (event) {
        event.stopPropagation();
      }
      this.$trackCustomEvent("click_feuerwerk2025_zur-merkliste");
      this.$store.dispatch("addShoppinglistItem", this.productNr);
    },
    removeItem(event) {
      if (event) {
        event.stopPropagation();
      }
      this.$store.dispatch("removeShoppinglistItem", this.productNr);
    },
  },
  computed: {
    isOnList() {
      return this.$store.getters.shoppinglistItem(this.productNr);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/settings";
.shoppinglist-add-button {
  button,
  .button {
    width: 100%;
    height: 50px;
    cursor: pointer;
    color: #ffffff;
    img {
      width: 12px;
      height: auto;
      display: inline-block;
      margin-left: 8px;
    }
    @include mobile {
      padding: 11px;
    }
    &.button-added {
      background: $color-green;
    }
  }
}
</style>
